import React from 'react';
import { X } from 'lucide-react';

const TabNavigation = ({
  tabs,
  activeClientTab,
  handleClientTabChange,
  editingTabId,
  editingTabName,
  editTabInputRef,
  handleTabDoubleClick,
  handleTabNameKeyDown,
  handleTabNameSave,
  hoveredTab,
  setHoveredTab,
  handleDeleteTab,
  setEditingTabName
}) => {
  return (
    <div className="flex items-center mb-4 pl-4 overflow-x-auto">
      {tabs.map(tab => (
        <div
          key={tab.tab_id}
          className="relative"
          onMouseEnter={() => setHoveredTab(tab.tab_id)}
          onMouseLeave={() => setHoveredTab(null)}
        >
          {editingTabId === tab.tab_id ? (
            <input
              ref={editTabInputRef}
              type="text"
              value={editingTabName}
              onChange={(e) => setEditingTabName(e.target.value)}
              onKeyDown={handleTabNameKeyDown}
              onBlur={handleTabNameSave}
              className="py-1.5 px-3 text-sm font-medium border border-secondary rounded focus:outline-none focus:ring-2 focus:ring-secondary/20 min-w-[100px]"
            />
          ) : (
            <button
              onClick={() => handleClientTabChange(tab.tab_id)}
              onDoubleClick={() => handleTabDoubleClick(tab)}
              className={`py-2 px-4 text-sm font-medium border-b-2 transition-colors ${activeClientTab === tab.tab_id
                ? 'border-secondary text-secondary'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
            >
              {tab.tab_name}
            </button>
          )}
          {hoveredTab === tab.tab_id && !editingTabId &&
            !tab.tab_id.startsWith("static_") && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteTab(tab.tab_id);
                }}
                className="absolute top-0 right-0 -mt-2 -mr-2 bg-red-500 text-white rounded-full p-0.5 hover:bg-red-600 transition-colors"
                title="Delete tab"
              >
                <X size={12} />
              </button>
            )}
        </div>
      ))}
    </div>
  );
};

export default TabNavigation;